const LocaleSettings = {
  locale: process.env.PREACT_APP_LOCALE,
  isRtl: ['fa', 'ar'].includes(process.env.PREACT_APP_LOCALE) ? true : false
}

export default LocaleSettings
